module.exports = __webpack_public_path__ + "img/portrait-elsa.08f4ff8.jpg";